import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { api, ONBOARDING_STATUSES } from '../../../lib/acceleratorApi';

const AdminContext = createContext(null);

export function AdminProvider({ children }) {
  const [startups, setStartups] = useState([]);
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [version, setVersion] = useState(0);

  const refreshStartups = useCallback(async () => {
    const s = await api.getStartups();
    setStartups(s);
    return s;
  }, []);

  const refreshTeam = useCallback(async () => {
    const tm = await api.getUsers();
    setTeam(tm);
    return tm;
  }, []);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const [s, tm] = await Promise.all([api.getStartups(), api.getUsers()]);
      setStartups(s);
      setTeam(tm);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
    setVersion((v) => v + 1);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const onboardedStartups = startups.filter((s) => s.status === 'ONBOARDED');
  const requestedStartups = startups.filter((s) => s.status === 'REQUESTED');
  const pipelineStartups = startups.filter((s) => ONBOARDING_STATUSES.includes(s.status));
  const mentors = team.filter((u) => u.role === 'CXO');
  const investors = team.filter((u) => u.role === 'INVESTOR');

  const value = {
    startups, team, loading, error, refresh, refreshStartups, refreshTeam,
    onboardedStartups, requestedStartups, pipelineStartups, mentors, investors,
    modal, setModal, form, setForm, version
  };

  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
}

export function useAdmin() {
  const ctx = useContext(AdminContext);
  if (!ctx) throw new Error('useAdmin must be used within AdminProvider');
  return ctx;
}
